import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import thryivLogo from "../assets/Thryiv_logo_tm_TB.png";
import { fetchProtectedImage } from "../services/media";
import { BRAND } from "../styles/authTheme";

const CompanyLogo = ({
  logoPath,
  companyName,
  height = 44,
  fallbackSrc = thryivLogo,
  alt,
}) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let active = true;

    setFailed(false);
    setSrc(null);

    if (!logoPath) {
      return undefined;
    }

    fetchProtectedImage(logoPath)
      .then((url) => {
        if (!active) {
          if (url?.startsWith("blob:")) URL.revokeObjectURL(url);
          return;
        }
        objectUrl = url?.startsWith("blob:") ? url : null;
        setSrc(url);
      })
      .catch(() => {
        if (active) setFailed(true);
      });

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [logoPath]);

  const imageSrc = failed || !logoPath ? fallbackSrc : src;
  const showFallback = failed || !logoPath || !src;

  if (!imageSrc && logoPath && !failed) {
    return (
      <Box
        sx={{
          width: height,
          height,
          borderRadius: "10px",
          bgcolor: "#F1F5F9",
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: height,
        height,
        borderRadius: "10px",
        border: `1px solid ${BRAND.border}`,
        bgcolor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        flexShrink: 0,
        p: 0.5,
      }}
    >
      <Box
        component="img"
        src={imageSrc || fallbackSrc}
        alt={alt || companyName || "Company logo"}
        sx={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          opacity: showFallback && !logoPath ? 1 : 1,
        }}
      />
    </Box>
  );
};

export default CompanyLogo;
